import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const userApi = createAsyncThunk("user", async () => {
  const response = await axiosInstance.get("/user");
  return response.data;
});

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(userApi.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(userApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default userSlice.reducer;
